import tokens from "./tokens.json";
import baseTheme from "../../theme/baseTheme.json";
import primitives from "../../theme/primitives.json";
import { resolveTokens } from "../../theme/resolveTokens";

import type { TenantConfig } from "../types";

const colors = resolveTokens({ primitives, baseTheme, tenant: tokens });

export const tenant = {
  id: "inpay",
  name: {
    product: "Inpay Customer Application",
    company: "Inpay",
  },
  html: {
    title: "Customer App",
    description: "Inpay Customers Application",
    themeColor: colors.actionPrimary,
  },
  support: {
    email: "support@inpay.com",
  },
  urls: {
    aboutUs: "https://www.inpay.com/about-us/",
    contactUs: "https://www.inpay.com/contact-us/",
    privacyPolicy: "https://www.inpay.com/privacy-policy/",
  },
  domains: {
    root: "inpay.com",
  },
  colors,
  authPageLogo: "primary",
  identity: {
    legalName: "Inpay A/S",
    addressLines: ["Toldbodgade 55B", "1253 Copenhagen", "Denmark"],
    website: {
      href: "https://www.inpay.com/",
      label: "inpay.com",
    },
  },
} satisfies TenantConfig;
